import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MyHttpClient } from '../../app/http-client.service';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EntityService } from '../entity.service';


@Injectable({
  providedIn: 'root'
})
export class InvoiceDetailsService {


  constructor(private http: MyHttpClient,
    private entityService: EntityService) { }
  server = `${environment.server}`;
  emailInvoiceUrl = this.server + '/api/emailInvoice';

  emailInvoice(orderId, userId, todayDate) {
    return this.http.get(this.emailInvoiceUrl + '/' + orderId + '/' + userId + '/' + todayDate ).pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(error);
  }
}
